import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';

export function setupSearch(
  formControl: FormControl,
  router: Router,
  debounceTimeMs: number = 500,
  resetPage: boolean = true,
): Subscription {
  return formControl.valueChanges.pipe(debounceTime(debounceTimeMs), distinctUntilChanged()).subscribe((value) => {
    const search = value?.trim() || '';
    const queryParams: { search: string; page?: number } = { search };

    if (resetPage) {
      queryParams.page = 1;
    }

    router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  });
}

export function initializeSearchFromParams(formControl: FormControl, searchParam: string): void {
  if (formControl.value !== searchParam) {
    formControl.setValue(searchParam, { emitEvent: false });
  }
}
